import http from '../util/http.js'

export const List = (noteName,groupId,page,pageSize = 10) => http.get('/note/list',{noteName,groupId,page,pageSize})
export const DetailNote = (id) => http.get('/note/detail',{id})
export const Delete = (id) => http.get('/note/delete',{id})
export const GetByUserIdNote = () => http.get('/note/getByUserIdNote',{})
export const Save = (params) => http.post('/note/save',params)